module.exports = __webpack_public_path__ + "static/sodexo-554fe100f2f74902146acf12356a16b0.jpg";